module.exports = __webpack_public_path__ + "static/img/icon_wind.fdfebeee.png";